import React, { useEffect, useState } from "react";
import { CaretDown, CaretUp, Container, Flex, Input } from "@cisco/spaces-dash-lib-styleguide";

function InputWithKeylist({ value, metadataKeyList, onChange, label, placeholder, required = false }) {
  const [metadataKeyListFiltered, setMetadataKeyListFiltered] = useState([]);
  const [listVisible, setListVisible] = useState(false);

  useEffect(() => {
    if (value && value?.trim !== "") {
      setMetadataKeyListFiltered(metadataKeyList?.filter((key) => key?.toLowerCase().includes(value?.toLowerCase())));
    } else {
      setMetadataKeyListFiltered(metadataKeyList);
    }
  }, [metadataKeyList, value]);

  return (
    <div>
      <Input
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        label={label}
        suffix={
          <Input.FunctionalButton
            onClick={() => {
              // show metadata key list
              setListVisible((prevVal) => !prevVal);
            }}
          >
            {!listVisible && <CaretDown size={16} weight="bold" />}
            {listVisible && <CaretUp size={16} weight="bold" />}
          </Input.FunctionalButton>
        }
        onFocus={() => setListVisible(true)}
        onBlur={() => setListVisible(false)}
        required={required}
      />
      {listVisible && metadataKeyListFiltered.length !== 0 && (
        <Container style={{ maxHeight: "200px", overflow: "auto", position: "absolute", marginTop: "8px", width: "200px", zIndex: 1000 }}>
          <Flex gap={16} direction="vertical">
            {metadataKeyListFiltered.map((key) => (
              <Flex
                key={key}
                onMouseDown={() => {
                  onChange({ target: { value: key } });
                  setListVisible(false);
                }}
                style={{ cursor: "pointer" }}
              >
                {key}
              </Flex>
            ))}
          </Flex>
        </Container>
      )}
    </div>
  );
}

export default InputWithKeylist;
